const lbaTagInput = angular.module('app.lbaTagInput', []);

lbaTagInput.controller('lbaTagInputCtrl', require('./lbaTagInputCtrl'));
lbaTagInput.directive('lbaTagInput', require('./lbaTagInputDir'));

export default lbaTagInput;



// WEBPACK FOOTER //
// ./src/components/lbaTagInput/index.js